import Rete, { Socket} from "rete";
import VueOperationsControl from "./StatsOperationControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class StatsOperationsControl extends Rete.Control {
  constructor(emitter, key) {
    super(key);
    this.render = "vue";
    this.component = VueOperationsControl;
    this.props = { emitter, ikey: key };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const StatsOperationSocket = new Socket("StatsOperation");
StatsOperationSocket.combineWith(AnyTypeSocket);
export { StatsOperationSocket };

